var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m424.75 125.8a16 16 0 0 0 16-16v-93.8a16 16 0 0 0 -16-16h-93.8a16 16 0 0 0 0 32h55.177l-62.779 62.776c-60.679-49.322-150.329-45.745-206.8 10.731-60.3 60.295-60.3 158.4 0 218.7a153.9 153.9 0 0 0 93.352 44.393v40.155h-55.25a16 16 0 1 0 0 32h55.25v55.245a16 16 0 0 0 32 0v-55.249h55.249a16 16 0 0 0 0-32h-55.249v-40.151a153.911 153.911 0 0 0 93.349-44.389c56.476-56.476 60.052-146.125 10.731-206.8l62.77-62.783v55.172a16 16 0 0 0 16 16zm-112.133 175.78a122.587 122.587 0 1 1 0-173.446 122.786 122.786 0 0 1 0 173.446zm-17.033-114.011a16 16 0 0 1 -16 16h-107.384a16 16 0 0 1 0-32h107.38a16 16 0 0 1 16.004 16zm0 54.576a16 16 0 0 1 -16 16h-107.384a16 16 0 0 1 0-32h107.38a16 16 0 0 1 16.004 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquality);
export default __webpack_public_path__ + "static/media/equality.7de3928c329fb95de2cd415ee1893750.svg";
export { ForwardRef as ReactComponent };